export default {"src":"/_next/static/media/k4.830399b4.svg","height":44,"width":43};